import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,       // 5 min - admin data rarely changes mid-session
      gcTime: 30 * 60_000,         // keep unused cache 30 min
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: false,        // don't refetch if data is still fresh
    },
  },
});
